import React from "react";
import styles from "./Header.module.css";

const RedMarker = () => {
  return <div className={styles.marker}></div>;
};

export default RedMarker;